function cloneResponse(response) {
    if (typeof response === 'undefined') {
        return {};
    }

    return JSON.parse(JSON.stringify(response));
}

function getDelay(config, actionConfig) {
    if (actionConfig && typeof actionConfig.delay_ms === 'number') {
        return actionConfig.delay_ms;
    }

    if (config && typeof config.delay_ms === 'number') {
        return config.delay_ms;
    }

    return 0;
}

function getMode(actionConfig) {
    return actionConfig && actionConfig.mode === 'error' ? 'error' : 'success';
}

function getActionConfig(config, actionName) {
    if (!config || typeof config !== 'object') {
        return null;
    }

    const actions = config.actions && typeof config.actions === 'object'
        ? config.actions
        : config;

    return actions[actionName] || null;
}

function invokeMock(actionName, config, actionConfig, onSuccess, onError, logger) {
    const mode = getMode(actionConfig);
    const response = cloneResponse(actionConfig.response);
    const callback = mode === 'error' ? onError : onSuccess;

    logger.info('Integrator mock invoked', {
        action: actionName,
        mode,
        response,
    });

    window.setTimeout(() => {
        if (typeof callback === 'function') {
            callback(response);
        }
    }, getDelay(config, actionConfig));
}

function postMessageMock(actionName, config, actionConfig, logger) {
    const response = cloneResponse(actionConfig.response);

    logger.info('Integrator iframe mock invoked', {
        action: actionName,
        response,
    });

    console.log('Integrator iframe mock invoked', {
        action: actionName,
        response,
    });

    window.setTimeout(() => {
        window.postMessage(response, window.location.origin);
    }, getDelay(config, actionConfig));
}

function patchMethod(target, methodName, replacement) {
    if (typeof target[methodName] === 'function') {
        target[methodName] = replacement;
    }
}

export default function applyIntegratorMocks(integrator, config, logger) {
    if (!config || typeof config !== 'object' || config.enabled !== true) {
        return integrator;
    }

    const identifyIframeConfig = getActionConfig(config, 'identify_iframe');
    if (identifyIframeConfig) {
        patchMethod(integrator, 'heIframeIdentify', () => {
            postMessageMock('identify_iframe', config, identifyIframeConfig, logger);
        });
        patchMethod(integrator, 'customHeIframeIdentify', () => {
            postMessageMock('identify_iframe', config, identifyIframeConfig, logger);
        });
        patchMethod(integrator, 'customHeIframeIdentifyNoBaseData', () => {
            postMessageMock('identify_iframe', config, identifyIframeConfig, logger);
        });
        patchMethod(integrator, 'customHeIframeIdentifyBaseUrl', () => {
            postMessageMock('identify_iframe', config, identifyIframeConfig, logger);
        });
    }

    const subscribeConfig = getActionConfig(config, 'subscribe');
    if (subscribeConfig) {
        patchMethod(integrator, 'LPSubscribeRequest', (data, endpoint, onSuccess, onError) => {
            invokeMock('subscribe', config, subscribeConfig, onSuccess, onError, logger);
        });
    }

    const otpGenerateConfig = getActionConfig(config, 'otp_generate');
    if (otpGenerateConfig) {
        patchMethod(integrator, 'LPOtpGenerateCustomRequest', (data, endpoint, onSuccess, onError) => {
            invokeMock('otp_generate', config, otpGenerateConfig, onSuccess, onError, logger);
        });
    }

    const otpValidateConfig = getActionConfig(config, 'otp_validate');
    if (otpValidateConfig) {
        patchMethod(integrator, 'LPOtpSubscribeCustomRequest', (data, endpoint, onSuccess, onError) => {
            invokeMock('otp_validate', config, otpValidateConfig, onSuccess, onError, logger);
        });
    }

    const checkSubscriptionConfig = getActionConfig(config, 'check_subscription');
    if (checkSubscriptionConfig) {
        patchMethod(integrator, 'LPCheckSubscriptionRequest', (data, onSuccess, onError) => {
            invokeMock('check_subscription', config, checkSubscriptionConfig, onSuccess, onError, logger);
        });
    }

    const pollSubscriptionConfig = getActionConfig(config, 'poll_subscription');
    if (pollSubscriptionConfig) {
        patchMethod(integrator, 'pollGetRequest', (data, onSuccess, onError) => {
            invokeMock('poll_subscription', config, pollSubscriptionConfig, onSuccess, onError, logger);
        });
    }

    logger.info('Integrator mocks enabled', {
        actions: Object.keys(config.actions || {}),
    });

    return integrator;
}
